import VehiculeSlider from "../class/VehiculeSlider";
import {SuperAlign} from "../class/SuperAlign";

new VehiculeSlider('.swiper-vehicles').init();

const superAlign = new SuperAlign('.js-text-normalize');
superAlign.init();

const superAlign2 = new SuperAlign('.js-text-normalize-2');
superAlign2.init();
